import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On each route change, moves focus to `<main id="main">` so screen readers
 * announce the new page content instead of staying on the previous element.
 */
export function FocusOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.getElementById("main");
    if (main) {
      main.setAttribute("tabindex", "-1");
      main.focus({ preventScroll: true });
    }
  }, [pathname]);

  return null;
}
